import axios from "../../utils/axios";

async function getInventoryItems(params) {
  return await axios.get(`/single/inventory`, {
    params,
  });
}

async function create(data) {
  return await axios.post(`/single/inventory`, data);
}

async function update(itemId, data) {
  return await axios.patch(`/single/inventory/${itemId}`, data);
}

export const inventoryService = {
  getInventoryItems,
  create,
  update,
};

export default inventoryService;
